import { useState } from "react";

export default function FAQ() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(0);

  const faqs = [
    {
      question: "Como funciona?",
      answer:
        "Após a compra, você preenche um formulário detalhado sobre seus objetivos, histórico e disponibilidade. Com base nessas informações, criamos um treino 100% personalizado para você, com acompanhamento semanal via WhatsApp para ajustes e correções.",
    },
    {
      question: "Em quanto tempo recebo meu treino?",
      answer:
        "Após o preenchimento do formulário e confirmação do pagamento, você receberá seu treino personalizado em até 5 dias. O acompanhamento começa imediatamente após a entrega.",
    },
    {
      question: "A mentoria funciona para iniciantes?",
      answer:
        "Sim! A mentoria é totalmente personalizada para seu nível atual. Se você é iniciante, criaremos um programa progressivo e seguro para você começar da forma correta e evoluir gradualmente.",
    },
    {
      question: "Preciso treinar em academia para participar?",
      answer:
        "Sim! Nossos treinos são totalmente desenvolvidos para serem feitos em academia.",
    },
    {
      question: "Tenho lesão, posso fazer?",
      answer:
        "Sim! Adaptamos completamente o treino considerando suas limitações e histórico de lesões. Criamos exercícios alternativos seguros e eficazes, sempre priorizando sua recuperação e evolução sem riscos. É importante informar todas as suas condições no formulário inicial.",
    },
    {
      question: "Como funciona os ajustes e correções?",
      answer:
        "Você pode enviar vídeos dos exercícios com maior dificuldade ou dúvidas uma vez por semana durante a consultoria. Isso nos permite fazer ajustes precisos e garantir que você esteja sempre progredindo da melhor forma possível.",
    },

    {
      question: "Em quanto tempo vou começar a ver os resultados?",
      answer:
        "Os resultados variam de pessoa para pessoa, mas se o protocolo for seguido corretamente, logo nas primeiras semanas você já vai notar mudanças visíveis no corpo e no desempenho. Aumento de força, definição e disposição durante os treinos.",
    },
    {
      question: "Homens podem comprar a mentoria?",
      answer:
        "A Mentoria Team RB foi desenvolvida especificamente para o universo feminino, considerando as particularidades do treino para mulheres. Por isso, é direcionada exclusivamente para mulheres que buscam transformação corporal.",
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className='py-20 bg-white'>
      <div className='max-w-4xl mx-auto px-6 lg:px-8'>
        <div className='text-center mb-16'>
          <h2 className='text-4xl lg:text-5xl font-bold text-gray-900 mb-4 font-montserrat'>
            Perguntas <span className='text-purple-600'>Frequentes</span>
          </h2>
          <p className='text-xl text-gray-600 font-poppins'>
            Tire suas dúvidas sobre a Mentoria Team RB
          </p>
        </div>

        <div className='space-y-4'>
          {faqs.map((faq, index) => (
            <div
              key={index}
              className='bg-white border border-purple-100 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300'
            >
              <button
                onClick={() => toggleFAQ(index)}
                className='w-full px-6 py-6 text-left flex items-center justify-between cursor-pointer'
              >
                <h3 className='text-lg font-semibold text-gray-900 pr-4 font-poppins'>
                  {faq.question}
                </h3>
                <div
                  className={`w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                    openFAQ === index ? "rotate-180" : ""
                  }`}
                >
                  <i className='ri-arrow-down-s-line text-purple-600'></i>
                </div>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openFAQ === index
                    ? "max-h-96 opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <div className='px-6 pb-6'>
                  <p className='text-gray-700 leading-relaxed font-inter'>
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className='text-center mt-12'>
          <div className='bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl p-8'>
            <h3 className='text-2xl font-bold text-gray-900 mb-4 font-montserrat'>
              Ainda tem dúvidas?
            </h3>
            <p className='text-gray-700 mb-6 font-inter'>
              Entre em contato conosco e teremos prazer em ajudar você
            </p>
            <a
              href='https://wa.me/5524992203091'
              target='_blank'
              rel='noopener noreferrer'
              className='inline-flex items-center px-6 py-3 bg-purple-500 hover:bg-purple-600 text-white font-semibold rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer font-poppins'
            >
              <i className='ri-chat-3-line mr-2'></i>
              Falar Conosco
            </a>
          </div>
        </div>
      </div>

      {/* Schema.org FAQ Structured Data */}
      <script type='application/ld+json'>
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((faq) => ({
            "@type": "Question",
            name: faq.question,
            acceptedAnswer: {
              "@type": "Answer",
              text: faq.answer,
            },
          })),
        })}
      </script>
    </section>
  );
}
